import { combineReducers } from "redux"

import settings from '@reducers/settings'
import section from '@reducers/section'
import document from '@reducers/document'
import catalogs from '@reducers/catalogs'
import admins from '@reducers/admins'
import profile from '@reducers/profile'
import sessionPermission from '@reducers/sessionPermission'
import email from '@reducers/email'
import evaluator from '@reducers/evaluator'
import digitalForm from '@reducers/digitalForm'

export default combineReducers({
  settings,
  section,
  document,
  catalogs,
  admins,
  profile,
  sessionPermission,
  email,
  evaluator,
  digitalForm
})